// extracted by mini-css-extract-plugin
export var activityContainer = "_lc-0";
export var typingIndicatorContainer = "_lc-1";
export var typingIndicatorDot = "_lc-2";
export var wave = "_lc-3";